import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: () => import('./views/pages/restaurantlist/Home.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Best Turkish Restaurants -  Mediterranean Halal Cuisine'
          }
        },
        {
          path: '/restaurants',
          name: 'restaurants',
          component: () => import('./views/pages/restaurantlist/Home.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Turkish Restaurant'
          }
        },
        {
          path: '/catering-restaurants',
          name: 'catering-restaurants',
          component: () => import('./views/pages/restaurantlist/CateringHome.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Turkish Restaurant'
          }
        },
        {
          path: '/terms-of-services',
          name: 'terms-of-services',
          component: () => import('./views/pages/termsOfService.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Terms of Services'
          }
        },
        {
          path: '/privacy-policy',
          name: 'privacy-policy',
          component: () => import('./views/pages/privacyPolicy.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Privacy Policy'
          }
        },
        {
          path: '/claim',
          name: 'claim',
          component: () => import('./views/pages/Claim.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Restaurant Claim'
          }
        },
        {
          path: '/coupons',
          name: 'coupons',
          component: () => import('./views/pages/Coupons.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Coupons'
          }
        },
        {
          path: '/events',
          name: 'events',
          component: () => import('./views/pages/Events.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Events'
          }
        },
        {
          path: '/specials',
          name: 'specials',
          component: () => import('./views/pages/Specials.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Specials'
          }
        },
        {
          path: '/careers',
          name: 'careers',
          component: () => import('./views/pages/Careers.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Careers'
          }
        },
        {
          path: '/gift-cards',
          name: 'gift-cards',
          component: () => import('./views/pages/GiftCards.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'Gift Cards'
          }
        },
        {
          path: '/about-us',
          name: 'about-us',
          component: () => import('./views/pages/AboutUs.vue'),
          meta: {
            authRequired: true,
            pageTitle: 'About Us'
          }
        },
        {
          path: '/restaurants/:restaurant_id/',
          name: 'restaurant-products',
          component: () => import('./views/pages/products/RestaurantProducts.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Restaurant Details', url: '/restaurants/:restaurant_id' },
              { title: 'Products', active: true }
            ],
            parent: 'restaurant-products',
            pageTitle: 'Restaurant Details',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/catering',
          name: 'catering',
          component: () => import('./views/pages/catering/RestaurantProducts.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Catering', url: '/catering', active: true }
            ],
            parent: 'catering',
            pageTitle: 'Catering',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/plugin-restaurants/:restaurant_id/',
          name: 'restaurant-plugin-products',
          component: () => import('./views/pages/products/RestaurantPluginProducts.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Restaurant Details', url: '/plugin-restaurants/:restaurant_id' },
              { title: 'Products', active: true }
            ],
            parent: 'restaurant-plugin-products',
            pageTitle: 'Restaurant Details',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/restaurants/:restaurant_id/:product_id',
          name: 'restaurant-products-detail',
          component: () => import('./views/pages/products/RestaurantProducts.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Restaurant Details' },
              { title: 'Products', active: true }
            ],
            parent: 'restaurant-products',
            pageTitle: 'Restaurant Details',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/checkout/:restaurant_id',
          name: 'checkout',
          component: () => import('./views/pages/restaurantlist/Checkout.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Checkout', active: true }
            ],
            pageTitle: 'Checkout',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/buy-gift-card',
          name: 'buy-gift-card',
          component: () => import('./views/pages/gift-card/Checkout.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Buy a Digital Gift Card ', active: true }
            ],
            pageTitle: 'Buy a Digital Gift Card',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/gift-card-thankyou',
          name: 'gift-card-thankyou',
          component: () => import('./views/pages/gift-card/ThankYou.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Thank You', active: true }
            ],
            pageTitle: 'Thank You'
          },
          props: true
        },
        {
          path: '/catering/offer',
          name: 'catering-offer',
          component: () => import('./views/pages/catering/CateringOffer.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Catering Offer', active: true }
            ],
            pageTitle: 'Catering Offer',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/blog/:content_id',
          name: 'blog',
          component: () => import('./views/pages/blog/PromotionBlog.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Promotion', active: true }
            ],
            pageTitle: 'Promotion',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/orders',
          name: 'orders',
          component: () => import('./views/pages/order/OrdersComponent.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Previous Orders', active: true }
            ],
            pageTitle: 'Previous Orders'
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/pages/profile/Profile.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Profile', active: true }
            ],
            pageTitle: 'Profile'
          }
        },
        {
          path: '/reservations',
          name: 'reservations',
          component: () => import('./views/pages/profile/Reservations.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reservations', active: true }
            ],
            pageTitle: 'Reservations'
          }
        },
        {
          path: '/catering/thankyou/:order_id',
          name: 'thankyouCatering',
          component: () => import('./views/pages/catering/ThankYou.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Thank You', active: true }
            ],
            pageTitle: 'Thank You'
          },
          props: true
        },
        {
          path: '/catering/offer/thankyou/:cateringOrderId/:offerToken',
          name: 'thankyouRestaurantCatering',
          component: () => import('./views/pages/catering/ThankYouCateringOffer.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Thank You', active: true }
            ],
            pageTitle: 'Thank You'
          },
          props: true
        },
        {
          path: '/catering/restaurant-offer/:cateringOrderOfferId/:offerToken',
          name: 'RestaurantOffer',
          component: () => import('./views/pages/catering/RestaurantOffer.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Catering Offer', active: true }
            ],
            pageTitle: 'Catering Offer'
          },
          props: true
        },
        {
          path: '/thankyou/:restaurant_id/:order_id',
          name: 'thankyou',
          component: () => import('./views/pages/order/ThankYou.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Thank You', active: true }
            ],
            pageTitle: 'Thank You'
          },
          props: true
        },
        {
          path: '/cities-map',
          name: 'cities-map',
          component: () => import('./views/pages/blog/CitiesMap.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Live Cities', active: true }
            ],
            pageTitle: 'Live Cities',
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/support',
          name: 'support',
          component: () => import('./views/pages/order/support.vue'),
          meta: {
            authRequired: true,
            breadcrumb: [
              { title: 'Order', url: '/' },
              { title: 'Support', active: true }
            ],
            pageTitle: 'Support'
          },
          props: true
        },
        {
          path: '/contact',
          name: 'contact',
          component: () => import('./views/pages/contact/Contact.vue'),
          meta: {
            authRequired: false,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Contact', active: true }
            ],
            pageTitle: 'Contact'
          },
          props: true
        },
        {
          path: '/accessibility',
          name: 'accessibility',
          component: () => import('./views/pages/accessibility/Accessibility.vue'),
          meta: {
            authRequired: false,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Accessibility', active: true }
            ],
            pageTitle: 'Accessibility'
          },
          props: true
        }
      ]
    },
    {
      path: '',
      component: () => import('./layouts/main/LiveCities.vue'),
      children: [
        {
          path: '/blog',
          name: 'Blog',
          component: () => import('./views/pages/blog/CompanyBlog.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Blog', active: true }
            ],
            pageTitle: 'Blog',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/turkish-restaurants-:city/turkish-restaurants-:area',
          name: 'live-cities-area',
          component: () => import('./views/pages/blog/CityRestaurants.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Live Cities', active: true }
            ],
            pageTitle: 'Live Cities',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/turkish-restaurants-:city',
          name: 'live-cities-city',
          component: () => import('./views/pages/blog/Cities.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Live Cities', active: true }
            ],
            pageTitle: 'Live Cities',
            rule: 'editor',
            authRequired: true
          },
          props: true
        },
        {
          path: '/turkish-restaurants',
          name: 'live-cities',
          component: () => import('./views/pages/blog/CityRestaurantsMain.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Live Cities', active: true }
            ],
            pageTitle: 'Live Cities',
            rule: 'editor',
            authRequired: true
          }
        }
      ]
    },
    {
      path: '',
      component: () => import('./layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          component: () => import('./views/pages/Login.vue')
        },
        {
          path: '/master-login',
          name: 'master-login',
          component: () => import('./views/pages/MasterLogin.vue')
        },
        {
          path: '/verify-mail/:token',
          name: 'verify-mail',
          component: () => import('@/views/pages/VerifyMail.vue'),
          props: true,
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/register',
          name: 'page-register',
          component: () => import('./views/pages/Register.vue')
        },
        {
          path: '/change-password/:token',
          name: 'change-password',
          meta: {
            authRequired: false
          },
          component: () => import('./views/pages/ChangePassword.vue'),
          props: true
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('./views/pages/ForgotPassword.vue')
        },
        {
          path: '/logout',
          name: 'page-logout',
          component: () => import('./views/pages/Logout.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('./views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})


router.beforeEach(async (to, from, next) => {

  // If auth required, check login. If login fails redirect to login page
  const isLoggedin = await store.state.api.isUserLoggedIn()

  if ((to.name === 'orders' || to.name === 'profile' || to.name === 'checkout' || to.name === 'buy-gift-card') && !isLoggedin) {
    if (to.fullPath !== '/') {
      next({name: 'page-login', query: {page: to.fullPath}})
    } else {
      next({name: 'page-login'})
    }
  } else if (to.name !== 'page-login' && isLoggedin) {
    if (to.query.page) {
      next({path: to.query.page})
    } else {
      next()
    }
  } else if (isLoggedin) {
    if (to.query.page) {
      next({path: to.query.page})
    } else {
      next({path: '/restaurants'})
    }
  } else {
    next()
  }

})

export default router
